import React, { useMemo, memo } from "react";
import PropTypes from "prop-types";
import ImageThumbnail from "./ImageThumbnail";

const EXPANDED_STACK_OVERLAY_STYLE = { position: "absolute", inset: 0, overflow: "hidden" };

function StackStripOverlay({
  imageFiles,
  onThumbnailSelect,
  onRemoveImage,
  onCloseStack,
  stackClosing,
  onAnimationEnd,
  stripBottom,
  stripMaxHeight,
}) {
  const listClassName = stackClosing
    ? "camera-stack-strip-close invisible-scrollbar overflow-y-auto pl-3 pr-3 pb-3 pt-3 flex flex-col gap-2 items-start"
    : "camera-stack-strip-animate invisible-scrollbar overflow-y-auto pl-3 pr-3 pb-3 pt-3 flex flex-col gap-2 items-start";
  const listStyle = useMemo(
    () => ({ position: "absolute", left: 0, bottom: stripBottom, maxHeight: stripMaxHeight }),
    [stripBottom, stripMaxHeight]
  );
  return (
    <div
      style={EXPANDED_STACK_OVERLAY_STYLE}
      className="flex flex-col items-start"
      role="dialog"
      aria-label="Captured pages"
      onClick={onCloseStack}
    >
      <div
        className={listClassName}
        style={listStyle}
        role="list"
        aria-label="Captured pages"
        onClick={(e) => e.stopPropagation()}
        onAnimationEnd={onAnimationEnd}
      >
        {[...imageFiles].reverse().map((item, i) => {
          const originalIndex = imageFiles.length - 1 - i;
          return (
            <ImageThumbnail
              key={`${originalIndex}-${String(item).slice(0, 24)}`}
              item={item}
              index={originalIndex}
              totalCount={imageFiles.length}
              displayPage={i + 1}
              onSelect={onThumbnailSelect}
              onRemove={onRemoveImage}
              stackSize
            />
          );
        })}
      </div>
    </div>
  );
}

StackStripOverlay.propTypes = {
  imageFiles: PropTypes.array.isRequired,
  onThumbnailSelect: PropTypes.func.isRequired,
  onRemoveImage: PropTypes.func.isRequired,
  onCloseStack: PropTypes.func.isRequired,
  stackClosing: PropTypes.bool.isRequired,
  onAnimationEnd: PropTypes.func.isRequired,
  stripBottom: PropTypes.string.isRequired,
  stripMaxHeight: PropTypes.string.isRequired,
};

export default memo(StackStripOverlay);
